// extracted by mini-css-extract-plugin
module.exports = {"container":"NotAuthorized_container__3tJDV"};